var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _setup.isMobile
        ? _c(_setup.InfoMobileMenu, {
            attrs: {
              title: _setup.currentTitle,
              "current-path": _vm.currentPath,
              routes: _setup.currentRoutes,
            },
          })
        : _c(
            "div",
            { staticClass: "mb-6 text-h5 text--text" },
            [_vm._t("title")],
            2
          ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "info-content",
          class: { "d-flex ga-8": !_setup.isMobile },
        },
        [
          !_setup.isMobile
            ? _c(
                "div",
                {
                  staticClass:
                    "flex-shrink-0 position-sticky align-self-start sticky-sidebar",
                },
                [
                  _c(_setup.InfoSidebar, {
                    attrs: {
                      path: _vm.currentPath,
                      routes: _setup.currentRoutes,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { class: { "flex-grow-1 info-content": !_setup.isMobile } },
            [_vm._t("content")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }